import { memo, useMemo } from 'react';
import { observer } from 'mobx-react';
import ServiceQuestion from './ServiceQuestion/ServiceQuestion';

import './style.scss';

const ServicesTopPage = observer(({ whatIsElephant }) => {
    // function convert data
    const convertDataComponent1 = (data = {}) => {
        const contents = Object.entries(data)
            .filter(([key]) => key.startsWith('content'))
            .map(([_, content = []], i) => {
                const [text1, text2] = content;
                return {
                    text1: text1 || '',
                    text2: text2 || '',
                    shape: shapeTypes[i]?.shape
                };
            });

        return {
            title: data.title || '',
            contents
        };
    };

    const convertDataComponent2 = (data = {}) => {
        const boxs = Object.entries(data)
            .filter(([key]) => key.startsWith('box'))
            .map(([_, box]) => {
                return {
                    heading: box?.heading || '',
                    text1: box?.content?.[0] || '',
                    text2: box?.content?.[1] || '',
                    image: {
                        key: box?.image?.key || '',
                        url: box?.image?.url || ''
                    }
                };
            });

        return {
            title: data.title || '',
            boxs
        };
    };

    const convertDataComponent3 = (data = {}) => {
        return {
            heading: data?.heading || '',
            content: data?.content || '',
            image: {
                key: data?.image?.key || '',
                url: data?.image?.url || ''
            }
        }
    };

    // const
    const [component1, component2, component3] = useMemo(() => {
        const com1Data = convertDataComponent1(whatIsElephant?.component1);
        const com2Data = convertDataComponent2(whatIsElephant?.component2);
        const com3Data = convertDataComponent3(whatIsElephant?.component3);

        return [com1Data, com2Data, com3Data];
    }, [whatIsElephant?.component1, whatIsElephant?.component2, whatIsElephant?.component3])

    const boxsComponent2 = (Array.isArray(component2?.boxs) && component2?.boxs?.length > 0)
        ? component2?.boxs?.filter(item => item?.heading || item?.text1 || item?.text2 || item?.image?.url)
        : [];

    return (
        <section id='id-section-services' className="section-services">
            <div className="section-services-curve">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1440 134"
                    preserveAspectRatio="none"
                >
                    <path d="M0,124 C480,-10 960,-10 1440,124 L1440,134 L0,134 Z" fill="" />
                </svg>
            </div>

            <div className="container">

                {/* Questions */}
                <ServiceQuestion data={component1} />

                {/* Card */}
                <div className="card-content">
                    <div className="title">
                        {component2?.title || ''}
                    </div>

                    <div className="services-card-list">
                        {Array.isArray(boxsComponent2) && boxsComponent2?.length > 0 && boxsComponent2?.map((item, index) => (
                            <Card
                                key={index}
                                heading={item?.heading}
                                text1={item?.text1}
                                text2={item?.text2}
                                imageUrl={item?.image?.url}
                            />
                        ))}
                    </div>
                </div>

                {/* What is elephamt */}
                <div id='id-about-elephamt' className="about-elephamt">
                    <div className="about-wrapper w-100">
                        {component3?.heading && (
                            <div className="about-title w-100">
                                <div className="title">{component3?.heading}</div>
                                <div className="about-title-border"></div>
                            </div>
                        )}

                        <div className="about-content">
                            <div className="text">
                                {component3?.content}
                            </div>
                            {component3?.image?.url && (
                                <div className="about-logo">
                                    <img src={component3?.image?.url} alt="" className="" />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
});

export default memo(ServicesTopPage);

const Card = ({ heading, text1, text2, imageUrl }) => {
    return (
        <div className="services-card-item">
            <div className="services-card-title">{heading}</div>
            <div className="services-card-desc">
                {text1}
                {text2 && (
                    <>
                        <br />
                        {text2}
                    </>
                )}
            </div>

            <img src={imageUrl} alt="" className="services-card-img" />
        </div>
    );
};

const shapeTypes = [
    {
        shape: 'oval'
    },
    {
        shape: 'rect'
    },
    {
        shape: 'oval'
    },
    {
        shape: 'oval'
    },
    {
        shape: 'rect'
    }
];
